'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const getEachDayOfISODatePartInterval = (isoDatePartInterval) => {
  return dateFns.eachDayOfInterval({
    start: dateFns.parseISO(isoDatePartInterval.start),
    end: dateFns.parseISO(isoDatePartInterval.end)
  }).map(parsers.dateToISODatePart);
};

module.exports = getEachDayOfISODatePartInterval;
//# sourceMappingURL=getEachDayOfISODatePartInterval.cjs.map
